const getMobEquipmenAssignmentFromBags = (bags) => {
  const items = (bags[0]?.value?.items || []).map((slot) => slot?.value).filter(Boolean);
  return {
    helmet: items.find(({ slot }) => slot === 'helmet')?.uid,
    torsoe: items.find(({ slot }) => slot === 'torsoe')?.uid,
    weapon: items.find(({ slot }) => slot === 'weapon')?.uid,
    off_hand: items.find(({ slot }) => slot === 'off_hand')?.uid,
    boots: items.find(({ slot }) => slot === 'boots')?.uid,
    left_ring: items.find(({ slot, hand }) => slot === 'ring' && hand === 'left')?.uid,
    right_ring: items.find(({ slot, hand }) => slot === 'ring' && hand === 'right')?.uid,
  };
};
module.exports = getMobEquipmenAssignmentFromBags;
